export default function CardWrapper({ children }) {
  return (
    <div className="shadow-[0_0_8px_0_#43434350] rounded-2xl #fff flex-1 h-full">
      {children}
    </div>
  );
}
